import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'gatsby'

import * as styles from './styles.module.css'

import chatapi from "../../../lib/chatapi"

const ChatIcon = () => {
	const [ fullviewmode, setFullviewmode ] = useState(1);
	const [ textinput, setTextinput ] = useState("");

	const [ chathistory, setChathistory ] = useState([]);
	const [ chatreplyhistory, setChatreplyhistory ] = useState([]);
	const [ chatreplying, setChatreplying ] = useState(false);

	const chattextinput = useRef(null);
	const chattextscrollholder = useRef(null);
	const chattextmainholder = useRef(null);

	const showChat = function(e) {
		if (e) {
			e.preventDefault();
		}
		setFullviewmode(2);
		// Scroll to bottom when the chat window is opened
		updateChatWindow()
	}

	const removeChat = function(e) {
		if (e) {
			e.preventDefault();
		}
		setFullviewmode(0);
	}

	const hideChat = function(e) {
		if (e) {
			e.preventDefault();
		}
		setFullviewmode(1);
	}

	const handleKeyDown = function(e) {
		if (e) {
			if (e.key === 'Enter') {
				pushChatMessage(textinput);
			}
		}
	}

	const onTextChange = function(e) {
		if (e) {
			e.preventDefault();

			setTextinput(e.target.value);
		}

	}

	const sendMessage = function(e) {
		if (e) {
			e.preventDefault();
		}
		pushChatMessage(textinput);
	}

	const pushChatMessage = function(newmsg) {
		var msgmarkup = "";

		if (newmsg.length > 0) {
			// TODO
			msgmarkup = newmsg;
		}
		if (msgmarkup.length > 0) {
			addChatHistory({
				msgtype: 0,
				timestamp: formatTimestamp(new Date()),
				rawmsg: newmsg,
				markup: msgmarkup
			});
		}

		setTextinput("");
		chattextinput.current.focus();


		setTimeout(function() {
			setChatreplying(true);
			setTimeout(function() {
				chatapi.send(newmsg).then((data)=>{
					updateChatTypingHistory({
						msgtype: 1,
						timestamp: formatTimestamp(new Date()),
						rawmsg: data,
						markup: data.message
					});
				}).catch((err)=>{
					if (false) {
						// Debug
						updateChatTypingHistory({
							msgtype: 1,
							timestamp: formatTimestamp(new Date()),
							rawmsg: err,
							markup: JSON.stringify(err)
						});

					} else {
						// Debug
						updateChatTypingHistory({
							msgtype: 1,
							timestamp: formatTimestamp(new Date()),
							rawmsg: "Sorry, there's some error in the chat.  May you try again later or contact our live agents instead?",
							markup: "Sorry, there's some error in the chat.  May you try again later or contact our live agents instead?"
						});

					}
				})
			}, 2000);
		}, 1000);

	}

	const updateChatTypingHistory = function(newmsgobj)
	{
		setChatreplyhistory(JSON.parse(JSON.stringify(chatreplyhistory)).concat([newmsgobj]));
		setChatreplying(false);
		updateChatWindow();
	}

	const addChatHistory = function(newmsgobj)
	{
		setChathistory(JSON.parse(JSON.stringify(chathistory)).concat([newmsgobj]));
		updateChatWindow();
	}

	const updateChatWindow = function()
	{
		window.setTimeout(function() {
			chattextscrollholder.current.scrollTo({
				top: chattextscrollholder.current.scrollHeight,
				behavior: "smooth"
			});
		}, 100);
	}

	const formatTimestamp = function(dateobj)
	{
		return dateobj.toLocaleString();
	}

	const handleSpecialCharacters = function(markup)
	{
		// Emoji etc
		return markup.replace(/ \:\)/g, " &#128512;");
	}

	const [finalHistory, setFinalHistory] = useState([])
	
	// Enclosed in a useEffect so the logic runs only when the chathistory and chatreplyhistory is updated
	// Does not trigger when other state e.g. fullviewmode, textinput changes
	useEffect(() => {
		//Merge chat history
		var finalhistory = [];
		var chatidx = 0;
		var chatreplyidx = 0;
		
		while (chatidx < chathistory.length || chatreplyidx < chatreplyhistory.length) {
			if (chatidx < chathistory.length && chatreplyidx < chatreplyhistory.length) {
				if (chatreplyhistory[chatreplyidx].timestamp < chathistory[chatidx].timestamp) {
					finalhistory.push(chatreplyhistory[chatreplyidx]);
					chatreplyidx++;
				} else {
					finalhistory.push(chathistory[chatidx]);
					chatidx++;
				}
			} else if (chatidx < chathistory.length) {
				finalhistory.push(chathistory[chatidx]);
				chatidx++;
			} else {
				finalhistory.push(chatreplyhistory[chatreplyidx]);
				chatreplyidx++;
			}
		} // while either has history

		setFinalHistory(finalhistory)
	}, [chathistory, chatreplyhistory])

	useEffect(() => {
		// Checks if chat history is not empty
		if (finalHistory.length > 0) {
			/* Stored in localStorage instead of sessionStorage so that the
			 * chat history persists across different tabs. 
			 */
			localStorage.setItem('chatHistory', JSON.stringify(finalHistory));
		}
	}, [finalHistory])

	// Fetch chat history from local storage
	useEffect(() => {
		// Fetch the data only if the chat window is shown
		if (fullviewmode !== 2) return;

		const storedChatHistory = localStorage.getItem('chatHistory');
		
		if (storedChatHistory !== null) {
			let userMessages = [];
			let replies = [];
			
			JSON.parse(storedChatHistory).map((chat) => {
				if (chat.msgtype === 0) {
					userMessages.push(chat);
				}

				if (chat.msgtype === 1) {
					replies.push(chat)
				}
			})

			setChathistory(userMessages);
			setChatreplyhistory(replies)
		} else {
			setChathistory([])
			setChatreplyhistory([])
		}
	}, [fullviewmode])

	const handleClearHistory = () => {
		setChathistory([])
		setChatreplyhistory([])
		localStorage.removeItem('chatHistory')
	}

	return <div className={fullviewmode===2?styles.mainholder+" "+styles.mainholderexpanded:styles.mainholder}>
		{fullviewmode===2?<div className={styles.chatdialog+" "+styles.roundedcorner+" "+styles.buttonshadow}>
			<div className={styles.chatdialogheading}>
				<img src="http://cdn.ngnw.ph/logo.png" alt="logo" />
				<span>Chat with us</span>
				<div className={styles.headingButtons}>
					<button title="Clear Chat" className={styles.roundedcorner} onClick={handleClearHistory}>
						CLEAR
					</button>
					<button title="Hide" className={styles.roundedcorner} onClick={hideChat}>
						X
					</button>
				</div>
			</div>
			<div ref={chattextmainholder} className={styles.chatdialogcontent}>
				<div className={styles.chatdialogcontentmsgaligner} />
				<div ref={chattextscrollholder} className={styles.chatdialogcontentmsgholder}>
					{finalHistory.map((msgobj, msgobjidx)=>{
						if (msgobj.msgtype===1) {
							return <div className={styles.chatdialogcontentmsg+" "+styles.chatdialogcontentmsgtypebot}>
								<div dangerouslySetInnerHTML={{__html: handleSpecialCharacters(msgobj.markup)}} />
								{msgobj.rawmsg.hasOwnProperty("button")&& <>
									{msgobj.rawmsg.button.length > 0 && <div className={styles.chatdialogcontentmsgbuttonoption}>
										{msgobj.rawmsg.button.map((buttonoption, buttonoptionidx) => {
											if (buttonoption.url.substring(0,4)==="http") {
												return <a href={buttonoption.url} target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{__html: buttonoption.label.replace(/\s/g,"&nbsp;")}} />
											}
											return <Link to={buttonoption.url}dangerouslySetInnerHTML={{__html: buttonoption.label.replace(/\s/g,"&nbsp;")}} />;
										})}
									</div>}
								</>}
								{msgobj.hasOwnProperty("timestamp") &&<span>{msgobj.timestamp}</span>}
							</div>
						}
						return <div className={styles.chatdialogcontentmsg+" "+styles.chatdialogcontentmsgtypeuser}>
								<div dangerouslySetInnerHTML={{__html: handleSpecialCharacters(msgobj.markup)}} />
								{msgobj.hasOwnProperty("timestamp") &&<span>{msgobj.timestamp}</span>}
							</div>
					})}
					{chatreplying && <div className={styles.chatdialogcontentmsgtypesystem}>Replying...</div>}
					{chatreplyhistory.length > 0 && <div className={styles.chatdialogagentoptionsholder}>
						Contact live agents:<br/>
						<div className={styles.chatdialogagentoptions}>
							<a target="_blank" rel="noopener noreferrer" href="https://m.me/negosyonow" title="@negosyonow FB Messenger">
								<img src="https://cdn.ngnw.ph/images/asset/icons/social/icon_messenger_green1.png" alt="FB Messenger" />
							</a>
							<a target="_blank" rel="noopener noreferrer" href="mailto:inquiries@negosyonow.com" title="inquiries@negosyonow.com">
								<img src="https://cdn.ngnw.ph/images/asset/icons/object/email_green1.png" alt="Send Email" />
							</a>
						</div>
					</div>}
				</div>
				<div className={styles.chatdialogcontentmsgaligner} />
			</div>
			<div className={styles.chatdialogsubmitarea}>
				<input autoFocus ref={chattextinput} placeholder={"Type your message here"} onChange={onTextChange} onKeyDown={handleKeyDown} value={textinput} />
				<button onClick={sendMessage} className={styles.chatdialogsubmitareabutton}>
					<img alt="Send" src="https://cdn.ngnw.ph/asset/button/send/send.png" srcset="https://cdn.ngnw.ph/asset/button/send/send.png 768w, https://cdn.ngnw.ph/asset/button/send/send_w512.png 512w, https://cdn.ngnw.ph/asset/button/send/send_w256.png 256w, https://cdn.ngnw.ph/asset/button/send/send_w128.png 128w" />
				</button>
			</div>
		</div>:<>{
			fullviewmode===1?
				<>
					<button title="Remove" className={styles.removebutton+" "+styles.roundedcorner} onClick={removeChat}>
						X
					</button>
					<button title="Chat with us" className={styles.chatbutton} onClick={showChat}>
						<img alt="Chat with Us" src="https://cdn.ngnw.ph/asset/button/chat/nnchatroundshadow.png" srcset="https://cdn.ngnw.ph/asset/button/chat/nnchatroundshadow.png 768w, https://cdn.ngnw.ph/asset/button/chat/nnchatroundshadow_w512.png 512w, https://cdn.ngnw.ph/asset/button/chat/nnchatroundshadow_w256.png 256w, https://cdn.ngnw.ph/asset/button/chat/nnchatroundshadow_w128.png 128w" />
					</button>
				</>
			:
			<></>
		}</>}
	</div>
}

export default ChatIcon
